import { IStorageProvider } from './IStorageProvider';
import { STORAGE_KEYS } from '../constants/storage';

export class DefaultStorageProvider implements IStorageProvider {
  get(key: string): string | null {
    if (typeof window === 'undefined') return null;
    try {
      return window.localStorage.getItem(key);
    } catch {
      return null;
    }
  }

  set(key: string, value: string): void {
    if (typeof window === 'undefined') return;
    try {
      window.localStorage.setItem(key, value);
    } catch {
      // Ignore quota errors or restricted access
    }
  }

  remove(key: string): void {
    if (typeof window === 'undefined') return;
    try {
      window.localStorage.removeItem(key);
    } catch {
      // Ignore
    }
  }

  clear(): void {
    if (typeof window === 'undefined') return;
    try {
      const knownKeys = [
        STORAGE_KEYS.ACCESS_TOKEN,
        STORAGE_KEYS.AUTH_STATE,
        STORAGE_KEYS.AUTH_REDIRECT_URI,
        STORAGE_KEYS.AUTH_VERIFIER
      ];
      knownKeys.forEach(k => window.localStorage.removeItem(k));
    } catch {
      // Ignore
    }
  }
}
